import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Carte de simulation de la pose : titre, description, bascule d'ancienneté du logement,
 * fourchette d'estimation et détail des prestations.
 */
@Component({
  selector: 'ng-casto-pose-simulation',
  templateUrl: './pose-simulation.component.html',
  styleUrls: ['./pose-simulation.component.scss'],
})
export class PoseSimulationComponent {
  /** Titre d'accroche (HTML autorisé). */
  @Input() title: string;
  /** Description de la prestation (HTML autorisé). */
  @Input() description: string;
  /** Libellé de la question sur l'ancienneté du logement (HTML autorisé). */
  @Input() moreThan2YearsLabel: string;
  /** Indique que le prix est en cours de calcul. */
  @Input() pricingLoading: boolean;
  /** Indique que l'installation est en cours de calcul. */
  @Input() installationLoading: boolean;
  /** Indique que le choix avec ou sans pose est en cours d'enregistrement. */
  @Input() setWithInstallationLoading: boolean;
  /** Indique que le chiffrage de la pose est exploitable. */
  @Input() isValid: boolean;
  /** Indique que le chiffrage de la pose a échoué. */
  @Input() hasError: boolean;
  /** Ancienneté du logement : plus de 2 ans (oui) ou non. */
  @Input() moreThan2Years: boolean;
  /** Montant total du projet (€ TTC). */
  @Input() total: number;
  /** Montant de la pose, inclus dans le total (€ TTC). */
  @Input() installation: number;
  /** Libellés des prestations incluses dans l'estimation. */
  @Input() included: string[] = [];
  /** Libellés des prestations à valider lors du relevé technique. */
  @Input() toValidate: string[] = [];
  /** Libellés des prestations non comprises dans l'estimation. */
  @Input() excluded: string[] = [];
  /** Émet la nouvelle valeur d'ancienneté du logement. */
  @Output() moreThan2YearsChange = new EventEmitter<boolean>();
  /** Émis au clic sur le bouton de nouvelle tentative. */
  @Output() retry = new EventEmitter<void>();

  /** Indique si les valeurs de l'estimation sont remplacées par des squelettes : calcul en cours ou chiffrage pas encore disponible. */
  get isLoading(): boolean {
    return (
      this.pricingLoading ||
      this.installationLoading ||
      this.setWithInstallationLoading ||
      (!this.isValid && !this.hasError)
    );
  }

  /** Indique si la sélection de l'ancienneté du logement est désactivée. */
  protected get toggleDisabled(): boolean {
    return this.pricingLoading || this.installationLoading;
  }
}
